var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "draggable",
            {
              staticClass: "item-list",
              on: { start: _vm.start, end: _vm.end },
              model: {
                value: _vm.fileList,
                callback: function ($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList",
              },
            },
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item + index,
                    staticClass: "itemI",
                    class: [
                      _vm.photoType == "detail" ? "item-detail" : "item-photo",
                    ],
                  },
                  [
                    _c("el-image", {
                      attrs: { fit: _vm.fit, src: item.url },
                      on: {
                        click: function ($event) {
                          return _vm.handlePictureCardPreview(item)
                        },
                      },
                    }),
                    _vm.photoType == "photo" && index == 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#2d46ee",
                              position: "absolute",
                              top: "100px",
                              left: "10px",
                            },
                          },
                          [_vm._v("（商品主图）")]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(item, index)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: { color: "#2d46ee" },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm.fileList.length <= _vm.limit - 1
                ? _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "upload",
                      class: [
                        _vm.photoType == "detail"
                          ? "item-detail bottom"
                          : "item-photo bottom",
                      ],
                      attrs: {
                        limit: _vm.limit,
                        action: "",
                        accept: "image/*",
                        "http-request": _vm.uploadFile,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        "file-list": _vm.fileList,
                        "on-preview": _vm.handlePictureCardPreview,
                        "on-exceed": _vm.handleExceed,
                        "show-file-list": false,
                        multiple: "",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": true },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }